import { InMemoryCache } from '@apollo/client';
import { currentUserVar } from '@/graphql/operations/user';
import { currentConnectorVar } from '@/graphql/operations/connector';
import { currentPlanTemplateVar } from '@/graphql/operations/playbook';
import { currentPlanVar } from '@/graphql/operations/plan';

export const apolloCache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        currentUser: {
          read() {
            return currentUserVar();
          },
        },
        currentConnector: {
          read() {
            return currentConnectorVar();
          },
        },
        currentTemplate: {
          read() {
            return currentPlanTemplateVar();
          },
        },
        currentPlan: {
          read() {
            return currentPlanVar();
          },
        },
      },
    },
  },
});
